
function setItem(name, value) {
  if (!name) return
  if (value === null || value === undefined || value === '') {
    localStorage.removeItem(name)
  } else {
    if (typeof value === 'object') {
      localStorage.setItem(name, JSON.stringify(value))
    } else {
      localStorage.setItem(name, value)
    }
  }
}

function getItem(name) {
  const data = localStorage.getItem(name)
  try {
    return JSON.parse(data) || ''
  } catch (e) {}
  return data || ''
}

const maxRecentVisit = 6

export default {
  namespaced: true,
  state: {
    user: undefined,
    permissions: null,
    roles: null,
    routesConfig: null,
    token: null,
    breadcrumb: [],
    query: JSON.parse(sessionStorage.getItem('breadcrumb-query') || '{}'),
    recentVisit: [],
  },
  getters: {
    getRecentVisit: (state) => {
      if (state.user) {
         state.recentVisit = getItem('set_recentVisit:' + state.user.id) || []
      }
      return state.recentVisit
    },
    user: (state) => {
      if (!state.user) {
        state.user = getItem('USER_INFO')
      }
      return state.user
    },
    permissions: (state) => {
      if (!state.permissions) {
        state.permissions = getItem(process.env.VUE_APP_PERMISSIONS_KEY) || []
      }
      return state.permissions
    },
    roles: (state) => {
      if (!state.roles) {
        state.roles = getItem(process.env.VUE_APP_ROLES_KEY) || []
      }
      return state.roles
    },
    routesConfig: (state) => {
      return state.routesConfig
    },
    token: (state) => () => {
      if (!state.token) {
        state.token = getItem('token')
      }
      return state.token
    },
  },
  mutations: {
    set_recentVisit(state, recentVisit) {
      if (recentVisit) {
        const currentRecentVisit = state.recentVisit
        if (currentRecentVisit.length >= maxRecentVisit) {
          currentRecentVisit.shift()
        }
        currentRecentVisit.push(recentVisit)
        state.recentVisit = currentRecentVisit
        if (state.user) {
          setItem('set_recentVisit:' + state.user.id, currentRecentVisit)
        }
      }
    },
    set_query(state, { key, value }) {
      state.query[key] = value
    },
    set_breadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb
    },
    setUser(state, user) {
      state.user = user
      setItem('USER_INFO', user)
    },
    setToken(state, token) {
      state.token = token
      setItem('token', token)
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    },
    setRoles(state, roles) {
      state.roles = roles
      setItem(process.env.VUE_APP_ROLES_KEY, JSON.stringify(roles))
    },
    setRoutesConfig(state, routesConfig) {
      state.routesConfig = routesConfig
    },
  },
  action: {
    logout({ commit }) {
      commit('setToken', null)
      commit('setRoutesConfig', null)
      commit('setUser', null)
      window.location.href = '/'
    },
  },
}
